import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ManageOrder.css";
import { useNavigate } from "react-router-dom";

const ManageOrder = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
   const navigate = useNavigate();
    const [openDropdown, setOpenDropdown] = useState(null);

   

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("userInfo"));
        if (!storedUser || !storedUser.token) {
          setError("Please login to view your orders.");
          setLoading(false);
          return;
        }

        const config = {
          headers: {
            Authorization: `Bearer ${storedUser.token}`,
          },
        };

        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER}/api/orders`,
          config
        );

        setOrders(data);
        console.log("data", data);
        
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError("Failed to load orders.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);
  const ViewOrder = (orders) => {
    navigate(`/admin/orders/${orders}`);
  };

  const UpdateOrder = (orders) => {
    navigate(`/admin/orders/edit-orders/${orders}`);
  };

  if (loading) return <p>Loading orders...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="orders-container">
      <h2 style={{ color: "#e6651b" }}>ALL Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>User</th>
              <th>Date</th>
              <th>Method</th>
              <th>payment</th>
              <th>orderStatus</th>
              <th>Amount</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={order._id}>
                <td>{order._id}</td>
                <td>{order.shippingAddress.name}</td>
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                <td>{order.paymentMethod}</td>
                <td>{order.paymentStatus}</td>
                <td>{order.orderStatus}</td>
                <td> ${order.totalAmount}</td>
               
                <td>
                  <div className="dropdownWrapper">
                    <p
                      className="actionBtn"
                      onClick={() =>
                        setOpenDropdown(openDropdown === index ? null : index)
                      }
                    >
                      ...
                    </p>

                    {openDropdown === index && (
                      <div className="dropdownMenu">
                        <div onClick={() => ViewOrder(order._id)}>view</div>
                        <div onClick={() => UpdateOrder(order._id)}>update</div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ManageOrder;


